import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import Seo from '../components/Seo';
import { SERVICES, IMAGES, SITE_URL } from '../mock';

const servicesSchema = {
  '@context': 'https://schema.org',
  '@type': 'MedicalWebPage',
  name: 'Therapy Services',
  url: `${SITE_URL}/services`,
  about: SERVICES.map((s) => ({ '@type': 'MedicalCondition', name: s.title })),
};

const ServiceCard = ({ title, text }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-white rounded-2xl border border-border p-6 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col">
      <h2 className="font-heading text-xl font-medium text-navy text-center">{title}</h2>
      <div
        className={`mt-3 text-sm text-muted-foreground leading-relaxed transition-all duration-300 ${
          open ? '' : 'line-clamp-2'
        }`}
      >
        {text}
      </div>
      <button
        onClick={() => setOpen((o) => !o)}
        className="mt-4 self-start inline-flex items-center gap-1.5 text-sm font-heading font-semibold text-[#3d6a9c] hover:text-navy transition-colors"
      >
        {open ? <Minus size={16} /> : <Plus size={16} />}
        {open ? 'Read less' : 'Read more'}
      </button>
    </div>
  );
};

const Services = () => {
  return (
    <div>
      <Seo
        title="Therapy Services — Insomnia, Anxiety, PTSD & More"
        description="Evidence-based therapy for insomnia, anxiety, depression, PTSD, panic attacks, grief, and more, using CBT-I, CBT, EMDR and ART. Virtual sessions with Dr. Bill Hoekstra, Psy.D."
        path="/services"
        schema={servicesSchema}
      />
      <div
        className="h-28 sm:h-36 w-full bg-cover bg-center"
        style={{ backgroundImage: `url(${IMAGES.waterPainting})` }}
      />
      <section className="bg-sky-band">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 text-center">
          <h1 className="font-heading font-light text-navy text-3xl sm:text-4xl md:text-5xl tracking-wide fade-up">
            Your Starting Point For A Better Life.
          </h1>
          <p className="mt-3 text-navy/70 text-lg">Find Relief Today</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s) => (
              <ServiceCard key={s.title} title={s.title} text={s.text} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
